
import React from 'react';
import Breadcrumb from '../../components/breadcrumb';
import './style.scss';

const NotFoundPage = () => {
  return (
    <>
      <Breadcrumb crumbs={["Page not found!"]}></Breadcrumb>
      <h1>{"Page not found"}</h1>
      <div className='grid dashboard-grid'>

      </div>
    </>
  );
};

export default NotFoundPage;
